import * as React from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';

const workflowsStyles = require('./workflows.css');

const DEFAULT_LABEL_SM = 4;
const DEFAULT_INPUT_SM = 8;

/** Label and control on the same row. */
export const StackedField = ({
  label,
  required,
  caption,
  children,
  htmlFor,
  labelSm = DEFAULT_LABEL_SM,
  inputSm = DEFAULT_INPUT_SM,
  alignTop = false,
}: {
  label: React.ReactNode;
  required?: boolean;
  caption?: string;
  children: React.ReactNode;
  htmlFor?: string;
  labelSm?: number;
  inputSm?: number;
  alignTop?: boolean;
}) => (
  <FormGroup
    row
    className={`${workflowsStyles.fieldRow}${
      alignTop ? ` ${workflowsStyles.fieldRowTop}` : ''
    }`}
  >
    <Label
      sm={labelSm}
      for={htmlFor}
      className={workflowsStyles.fieldLabelCol}
      onClick={(event) => {
        if (
          event.target instanceof Element &&
          event.target.closest('a')
        ) {
          event.preventDefault();
        }
      }}
    >
      {label}
      {required && <span className={workflowsStyles.requiredMark}> *</span>}
    </Label>
    <Col sm={inputSm}>
      {children}
      {caption && (
        <div className={workflowsStyles.fieldCaption}>{caption}</div>
      )}
    </Col>
  </FormGroup>
);

/** Label and switch on the same row, caption below the control column. */
export const InlineSwitchField = ({
  label,
  caption,
  id,
  checked,
  onChange,
  disabled = false,
  labelSm = DEFAULT_LABEL_SM,
  inputSm = DEFAULT_INPUT_SM,
}: {
  label: string;
  caption?: string;
  id: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  labelSm?: number;
  inputSm?: number;
}) => (
  <FormGroup row className={`${workflowsStyles.fieldRow} ${workflowsStyles.fieldRowTop}`}>
    <Label sm={labelSm} for={id} className={workflowsStyles.fieldLabelCol}>
      {label}
    </Label>
    <Col sm={inputSm} className={workflowsStyles.switchFieldCol}>
      <FormGroup switch className={workflowsStyles.switchGroup}>
        <Input
          type="switch"
          id={id}
          checked={checked}
          disabled={disabled}
          onChange={
            onChange ? (e) => onChange(e.target.checked) : undefined
          }
        />
      </FormGroup>
      {caption && (
        <div className={workflowsStyles.fieldCaption}>{caption}</div>
      )}
    </Col>
  </FormGroup>
);
